export class ColorsConstants {
    public static readonly GREEN = '#00c217';
    public static readonly RED = '#e60000';
    public static readonly BLUE = '#3355FF';
    public static readonly BLACK = '#000000';
    public static readonly LIGHT_RED = '#FFCABE' 
    public static readonly CONFIRM_BUTTON_COLOR_GREEN = "#18ce0f";    
    public static readonly CONFIRM_BUTTON_COLOR_RED = "#DC3545";
    public static readonly RED_BORDER = '4px solid #fc6c64';
}